import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function SpreadsheetFees() {
  return <ArticleLayout slug="spreadsheet-fees" />;
}